export default __webpack_public_path__ + "static/media/25101702.382197ba.jpg";